import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import AppLayout from '../components/AppLayout.vue'
// @ts-ignore: 自定义模块
import { getToken } from '../common/auth'

const router = createRouter({
  history: createWebHashHistory(), // 使用完整的 hash 路径
  routes: [
    {
      path: '/',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/dashboard',
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('../views/DashboardView.vue'),
        },
        {
          path: '/workbench',
          name: 'workbench',
          component: () => import('../views/WorkbenchView.vue'),
          meta: {
            title: '工作台',
            requiresAuth: true,
          },
        },
        {
          path: '/caregiver-management',
          name: 'caregiver-management',
          component: () => import('../views/CaregiverManagement.vue'),
        },
        {
          path: '/caregiver-detail/:id?',
          name: 'caregiver-detail',
          component: () => import('../views/CaregiverDetail.vue'),
        },
        {
          path: '/department-management',
          name: 'department-management',
          component: () => import('../views/DepartmentManagement.vue'),
        },
        {
          path: '/employee-management',
          name: 'employee-management',
          component: () => import('../views/EmployeeManagement.vue'),
          meta: {
            title: '职工管理',
            requiresAuth: true,
          },
        },

        {
          path: '/company-management',
          name: 'company-management',
          component: () => import('../views/CompanyManagement.vue'),
        },
        {
          path: '/service-object-management',
          name: 'service-object-management',
          component: () => import('../views/ServiceObjectManagement.vue'),
        },
        {
          path: '/service-detail/:id?',
          name: 'service-detail',
          component: () => import('../views/ServiceDetail.vue'),
        },
        {
          path: '/patient-sop-details/:id?',
          name: 'patient-sop-details',
          component: () => import('../views/PatientSopDetails.vue'),
          meta: {
            title: '流程详情',
            requiresAuth: true,
          },
        },
        {
          path: '/user-management',
          name: 'user-management',
          component: () => import('../views/UserManagement.vue'),
        },
        {
          path: '/order-management',
          name: 'order-management',
          component: () => import('../views/OrderManagement.vue'),
        },
        {
          path: '/order-detail/:id?',
          name: 'order-detail',
          component: () => import('../views/OrderDetail.vue'),
        },

        {
          path: '/care-record',
          name: 'care-record',
          component: () => import('../views/CareRecord.vue'),
        },

        {
          path: '/care-report-list',
          name: 'care-report-list',
          component: () => import('../views/CareReportList.vue'),
        },

        {
          path: '/recommendation-plan',
          name: 'recommendation-plan',
          component: () => import('../views/RecommendationPlan.vue'),
        },
        {
          path: '/care-monthly-report-detail/:id?',
          name: 'care-monthly-report-detail',
          component: () => import('../views/CareMonthlyReportDetail.vue'),
          meta: {
            title: '康护月报详情',
            requiresAuth: true,
          },
        },
        {
          path: '/analysis-details/:id?',
          name: 'analysis-details',
          component: () => import('../views/AnalysisDetailsView.vue'),
          meta: {
            title: '检测报告详情',
            requiresAuth: true,
          },
        },
        {
          path: '/activity-management',
          name: 'activity-management',
          component: () => import('../views/ActivityManagement.vue'),
          meta: {
            title: '活动管理',
            requiresAuth: true,
          },
        },
        {
          path: '/activity-publish',
          name: 'activity-publish',
          component: () => import('../views/ActivityPublishManagement.vue'),
          meta: {
            title: '发布活动',
            requiresAuth: true,
          },
        },
        {
          path: '/activity-edit/:id',
          name: 'activity-edit',
          component: () => import('../views/ActivityPublishManagement.vue'),
          meta: {
            title: '编辑活动',
            requiresAuth: true,
          },
        },
        {
          path: '/registration-record-management',
          name: 'registration-record-management',
          component: () => import('../views/RegistrationRecordManagement.vue'),
          meta: {
            title: '报名记录管理',
            requiresAuth: true,
          },
        },

        {
          path: '/account-settings',
          name: 'account-settings',
          component: () => import('../views/AccountSettingsView.vue'),
        },

        {
          path: '/about',
          name: 'about',
          component: () => import('../views/AboutView.vue'),
        },
        {
          path: '/contact',
          name: 'contact',
          component: () => import('../views/ContactSupportView.vue'),
          meta: {
            title: '联系我们',
            requiresAuth: false,
          },
        },
        {
          path: '/conversation-record',
          name: 'conversation-record',
          component: () => import('../views/ConversationRecord.vue'),
          meta: {
            title: '对话记录',
            requiresAuth: true,
          },
        },
        {
          path: '/service-quality-list',
          name: 'service-quality-list',
          component: () => import('../views/ServiceQualityList.vue'),
          meta: {
            title: '服务质量',
            requiresAuth: true,
          },
        },
        {
          path: '/urgent-events-list',
          name: 'urgent-events-list',
          component: () => import('../views/UrgentEventsList.vue'),
          meta: {
            title: '紧急事项',
            requiresAuth: true,
          },
        },
        {
          path: '/inspection-record-detail/:id?',
          name: 'inspection-record-detail',
          component: () => import('../views/InspectionRecordDetail.vue'),
          meta: {
            title: '抽查详情',
            requiresAuth: true,
          },
        },
        {
          path: '/satisfaction-survey-detail/:id?',
          name: 'satisfaction-survey-detail',
          component: () => import('../views/SatisfactionSurveyDetail.vue'),
          meta: {
            title: '满意度调查详情',
            requiresAuth: true,
          },
        },
        {
          path: '/adverse-event-detail/:id?',
          name: 'adverse-event-detail',
          component: () => import('../views/AdverseEventDetail.vue'),
          meta: {
            title: '不良事件详情',
            requiresAuth: true,
          },
        },
        {
          path: '/schedule-list',
          name: 'schedule-list',
          component: () => import('../views/ScheduleList.vue'),
          meta: {
            title: '排班管理',
            requiresAuth: true,
          },
        },
        {
          path: '/leave-history-list',
          name: 'leave-history-list',
          component: () => import('../views/LeaveHistoryList.vue'),
          meta: {
            title: '请假记录',
            requiresAuth: true,
          },
        },
        {
          path: '/order-taking-list',
          name: 'order-taking-list',
          component: () => import('../views/OrderTakingList.vue'),
          meta: {
            title: '可接订单列表',
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/hospital-register',
      name: 'hospital-register',
      component: () => import('../views/HospitalRegisterView.vue'),
    },
  ],
})

// 辅助函数：从URL中获取hospitalId参数
const getHospitalIdFromUrl = (to: any) => {
  // 从路由query参数中获取
  if (to.query.hospitalId) {
    return to.query.hospitalId as string
  }

  // 从目标路由的完整路径中获取参数
  const fullPath = to.fullPath || to.path
  if (fullPath && fullPath.includes('?')) {
    const queryString = fullPath.split('?')[1]
    const params = new URLSearchParams(queryString)
    if (params.has('hospitalId')) {
      return params.get('hospitalId')
    }
  }

  return null
}

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 检查用户是否需要登录
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  // 使用getToken函数检查登录状态
  const isLoggedIn = getToken() !== undefined

  // 检查是否有强制访问登录页的参数
  const forceLogin = to.query.force === 'true'

  // 特殊处理：如果访问dashboard页面且URL中有hospitalId参数，允许通过
  if (to.path === '/dashboard' && !isLoggedIn) {
    const hospitalId = getHospitalIdFromUrl(to)
    if (hospitalId && /^\d+$/.test(hospitalId)) {
      // URL中有有效的hospitalId参数，允许访问dashboard页面进行自动登录
      console.log('检测到URL中的hospitalId参数，允许访问dashboard页面进行自动登录:', hospitalId)
      next()
      return
    }
  }

  if (requiresAuth && !isLoggedIn) {
    // 需要登录但未登录，重定向到登录页
    next('/login')
  } else if (to.path === '/login' && isLoggedIn && !forceLogin) {
    // 已登录用户访问登录页，且没有强制登录参数，重定向到首页
    next('/')
  } else {
    // 其他情况正常导航
    next()
  }
})

export default router
